import { Component, Input, OnInit } from '@angular/core';
import { debug } from 'console';
import { skip } from 'rxjs/operators';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';
import { UseraccessserviceService } from 'src/app/services/useraccessservice.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-moduleslistitem',
  templateUrl: './moduleslistitem.component.html',
  styleUrls: ['./moduleslistitem.component.css'],
})
export class ModuleslistitemComponent implements OnInit {
  @Input() module: any;
  @Input() fromDash: boolean;
  lessoncount: number;
  logcount: number;
  skippedclasses: any;
  nextclass: any;
  url: any;
  queryParam: any;
  userjwt: string = '';
  environment;
  //hasliveclass;
  //livemeetinglink: string;

  constructor(
    private modulemanager: ModulemanagementService,
    private useraccessservice: UseraccessserviceService
  ) {
    this.environment = environment;
    this.userjwt = this.useraccessservice.getCurrentUserToken();
  }

  progress: number;
  async ngOnInit() {
    this.lessoncount = this.module.lessonCount;
    this.logcount = this.module.lessonlogcount;
    this.progress = this.module.order;

    this.skippedclasses = await this.modulemanager
      .getSkippedClasses(this.module.id)
      .toPromise();
    this.nextclass = this.skippedclasses[0];
    this.url = this.nextclass ? '/user/lesson' : '/user/moduledetails';
    this.queryParam = this.nextclass
      ? { classid: this.nextclass.id, moduleid: this.module.id }
      : { moduleID: this.module.id, dash: this.fromDash };

    // this.hasliveclass = this.module.hasLiveClass;
    // this.livemeetinglink = `${environment.ImpataAppAPIRoot}moduleclass/nextliveclass?userjwt=${this.userjwt}&moduleid=${this.module.id}`;
  }
}
